import * as types from "~/store/appDepositPayment/types";

export const createDepositApp = data => {
  return {
    type: types.CREATE_DEPOSIT_APP,
    data
  };
};
